






































































import Modal from './Modal.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({ components: { Modal } })
export default class CopyToPlatformModal extends Vue {
	@Prop({ type: String, required: true })
	readonly excludeId!: string

	protected selectedIds: string[] = []
	private resolveCallback: (ids: string[] | null) => void = () => {}
	private rejectCallback: (reason?: any) => void = () => {}

	get platforms() {
		return this.$store.getters['platforms/platforms'] || []
	}

	get otherPlatforms() {
		return (this.platforms as any[]).filter(
			(p: any) => p.id !== this.excludeId
		)
	}

	get allOtherPlatformIds() {
		return this.otherPlatforms.map((platform: any) => platform.id)
	}

	get allSelected() {
		return (
			this.otherPlatforms.length > 0 &&
			this.selectedIds.length === this.otherPlatforms.length
		)
	}

	open(): Promise<string[] | null> {
		this.selectAll()
		return new Promise((resolve, reject) => {
			this.resolveCallback = resolve
			this.rejectCallback = reject
			;(this.$refs.base as any).open()
		})
	}

	close() {
		;(this.$refs.base as any).close()
	}

	cancel() {
		this.resolveCallback(null)
		this.close()
	}

	selectAll() {
		this.selectedIds = [...this.allOtherPlatformIds]
	}

	deselectAll() {
		this.selectedIds = []
	}

	toggleSelectAll() {
		if (this.allSelected) {
			this.deselectAll()
			return
		}

		this.selectAll()
	}

	confirm() {
		this.resolveCallback([...this.selectedIds])
		this.close()
	}
}
